module.exports = __webpack_public_path__ + "img/13.ece59b93.svg";